import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { IVolunteerRole } from './models';
import { invalidateVolunteerRoles } from './useVolunteerRoles';

export const useCreateVolunteerRoleMutation = ({
	onError,
	onSuccess,
}: {
	onError?: (error: Api.IOperationResultNoValue) => void;
	onSuccess?: (data: IVolunteerRole) => void;
} = {}) => {
	const userSession = useUserSession();
	return useMutation({
		mutationFn: ({
			role,
			impersonationContext,
		}: {
			role: Pick<IVolunteerRole, 'name'>;
			impersonationContext?: Api.IImpersonationContext;
		}) =>
			userSession.webServiceHelper.callAsync<IVolunteerRole>(
				Api.ImpersonationBroker.composeApiUrl({ impersonationContext, urlPath: 'volunteering/roles' }),
				'POST',
				role
			),
		onSuccess: data => {
			invalidateVolunteerRoles();
			onSuccess?.(data);
		},
		onError,
	});
};
